module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "Ledia Lazeri_.5c0cdf6a.jpg" + "?" + Date.now();